import { toast } from 'react-toastify';
import StyledHeadingText from '../../components/Fonts/StyledHeadingText';
import * as Yup from "yup";
import { postOrderPayment } from '../../services/orders';
import InputField from '../../components/inputFields/InputField';
import FormikDropdown from '../../components/inputFields/FormikDropDown';
import { Form, Formik } from 'formik';
import Button from '../../components/buttons/Button';
import { useState } from 'react';
import ImagePickerField from '../../components/inputFields/ImagePickerField';

function OrderPaymentsAddPopView({ item, onOperation }) {
    const paymentTypeDropdown = [
        {
            label: "UPI",
            value: "UPI",
        },
        {
            label: "CARD",
            value: "CARD",
        },
        {
            label: "CASH",
            value: "CASH",
        },
        {
            label: "CHEQUE",
            value: "CHEQUE",
        },
        {
            label: "BANK_TRANSFER",
            value: "BANK_TRANSFER",
        },
        {
            label:"RAZORPAY",
            value:"Razorpay",
        },
        {
            label: "SBI_UPI",
            value: "SBI_UPI",
        },
        {
            label: "SARAL_UPI",
            value: "SARAL_UPI",
        }
    ];
    const [paymentScreenShot, setPaymentScreenShot] = useState(null);

    const handlePaymentScreenshotSelect = (file) => {
        setPaymentScreenShot(file);
    };

    const handleFormSubmit = async (values, { setSubmitting }) => {
        const formData = new FormData();
        formData.append("order", item.id);
        formData.append("payment_mode", values.payment_mode);
        formData.append("payment_amount", values.payment_amount);
        formData.append("payment_status", values.payment_status);
        formData.append("payment_id", values.payment_id);
        if (values.payment_date) {
            formData.append("payment_date", values.payment_date);
        }
        if (paymentScreenShot) {
            formData.append("image", paymentScreenShot);
        }

        try {
            const response = await postOrderPayment({ data: formData });

            if (response?.status === 201) {
                toast.success("Payment Added successfully!");
                onOperation();
            } else {
                let errors = "Opps! Something went wrong, please try again.";
                toast.error(errors);
            }
        } catch (error) {
            let errors =
                error?.response?.data?.error ||
                "Opps! Something went wrong, please try again.";
            toast.error(errors);
        }
        setSubmitting(false);
    };

    return (
        <div className="w-full flex-1">
            <StyledHeadingText text="Add Payments" />
            <Formik
                initialValues={{
                    payment_status: "COMPLETED",
                    payment_mode: "",
                    payment_date: new Date().toISOString().split("T")[0],
                    payment_id: "",
                    payment_amount: "",
                }}
                validationSchema={Yup.object({
                    payment_date: Yup.string().required("Date is required"),
                    payment_mode: Yup.string().required("Mode is required"),
                    payment_amount: Yup.string().required("Payment Amount is required"),
                })}
                onSubmit={handleFormSubmit}
            >
                {({ isSubmitting, setFieldValue, resetForm, values }) => (
                    <Form>
                        <div className="grid gap-2 grid-cols-1 md:grid-cols-2">
                            <FormikDropdown
                                label="Payment Mode"
                                name="payment_mode"
                                placeholder="Select Mode"
                                required={true}
                                options={paymentTypeDropdown}
                            />
                            <InputField
                                label={"Payment Amount"}
                                name="payment_amount"
                                placeholder={"Enter Amount"}
                                required
                            />
                            <InputField
                                label={"Payment Date"}
                                name="payment_date"
                                type="date"
                                required
                            />
                            <FormikDropdown
                                label="Status"
                                name="payment_status"
                                placeholder="Select Status"
                                required={true}
                                options={[
                                    { label: "Pending", value: "PENDING" },
                                    { label: "Completed", value: "COMPLETED" },
                                ]} />
                            <InputField
                                label={"Transaction Number"}
                                name="payment_id"
                                placeholder={"Enter Transaction Number"}
                            />
                            <ImagePickerField
                                label="Payment Proof"
                                name="payment_proof"
                                preloadedImage={paymentScreenShot}
                                placeholder='Select Payment Proof'
                                onImageSelect={handlePaymentScreenshotSelect}
                            />
                        </div>
                        {/* Buttons */}
                        <div className="py-5 flex justify-end gap-6">
                            <div>
                                <Button
                                    type="submit"
                                    className="text-white bg-primary hover:bg-primary-dark font-sm rounded-lg text-lg w-full px-8 py-1.5 text-center"
                                    disabled={isSubmitting}
                                >
                                    {isSubmitting ? "Saving..." : "Save"}
                                </Button>
                            </div>
                        </div>
                    </Form>
                )}
            </Formik>
        </div >);
}

export default OrderPaymentsAddPopView;